import { NativeQSenseControlPlugin } from '@/plugins/NativeQSenseControl';
import { QSenseHubControlPlugin } from '@/plugins/QSenseHubControl';

import { IAnnotationService } from '../interfaces/IAnnotationService';

export class AnnotationService implements IAnnotationService {
  constructor(private plugin: QSenseHubControlPlugin | NativeQSenseControlPlugin) {}

  async annotate(movementType: number, count: number): Promise<void> {
    if (count > 15) {
      throw new Error('Count cannot be greater than 15');
    }

    if (movementType > 15) {
      throw new Error('Annotation cannot be greater than 15');
    }

    await this.plugin.Annotate({ MeasurementType: movementType, Count: count });
  }

  async delete(count: number, measurementType: number): Promise<void> {
    await this.plugin.deleteAnnotation({ MeasurementType: measurementType, Count: count });
  }

  async restore(count: number, measurementType: number): Promise<void> {
    await this.plugin.restoreAnnotation({ MeasurementType: measurementType, Count: count });
  }

  async reset(): Promise<void> {
    await this.plugin.resetDeletedAnnotations();
  }
}
